var news = {
	selectors: {
		element: '[data-news]',
	},
	init: function () {
		var self = this;

		if (document.querySelector(self.selectors.element)) {
			var newsSlider = tns({
				container: self.selectors.element,
				items: 1,
				slideBy: 1,
				swipeAngle: false,
				speed: 800,
				controls: true,
				nav: false,
				mouseDrag: false,
				autoplay: false,
				controlsText: ['<i class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
				loop: false,
				gutter: 0,
				responsive: {
					768: {
						items: 2,
						gutter: 16
					},
					992: {
						items: 3
					}
				}
			});
		}
	},
};

export { news };
